export default __webpack_public_path__ + "static/media/os7.b49258a0.png";